<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[800px]">

    <strong class="block mb-8 pr-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200 tablet:px-6 desktop:px-10">
      <AtomsImagesIcon icon="truck" /> {{ $t('Předpokládaný termín doručení') }}
    </strong>

    <div class="tablet:px-6 desktop:px-10">
      <div v-for="option in dialog?.data.options" class="flex flex-wrap items-center gap-4 mb-4 pb-4 border-b border-neutral-200">
        <span>
          <AtomsImagesImage :src="`/img/shippings/${option.shipping.id}.png`" :alt="option.name" class="w-[70px] h-[25px] object-scale-down" />
        </span>
        <div class="flex-1 flex flex-wrap justify-between tablet:flex-nowrap">
          <span class="w-full tablet:w-auto">{{ option.shipping.name }}</span>
          <strong :class="getClassForDate(option.deliveryDate)">{{ getDeliveryText(option.deliveryDate) }}</strong>
        </div>
      </div>

      <div class="mt-8">
        <span v-html="$t('Uvedené termíny vychází z našich <strong>aktuálních dat o době doručení</strong> jednotlivých dopravců. I tak je <strong>prosím berte orientačně</strong>. Nedokážeme ovlivnit prodlevu v doručení například z důvodu problémů na straně dopravce, <strong>či zvýšené aktuální vytíženosti</strong>.')">
        </span> <AtomsTextLink :to="cache.getPageUrl(26553)" target="_blank" class="text-secondary-500 underline">{{ $t('Aktuální ceny dopravy') }}</AtomsTextLink>
      </div>
    </div>

  </AtomsGlobalDialog>
</template>
<script setup>

const i18n = useI18n();
const utils = useUtils();
const cache = useCache();

const dialog = computed(() => useDialog().get('deliveryOptions'));

const formatDate = (date) => {
  const options = { month: 'numeric', day: 'numeric' };

  return `${i18n.t(utils.getDayOfWeekName(date))} ${date.toLocaleDateString(i18n.locale, options)}`;
}

const minDate = computed(() => {
  const dates = dialog.value?.data.options.map((option) => option.deliveryDate);
  return new Date(Math.min(...dates));
});

const maxDate = computed(() => {
  const dates = dialog.value?.data.options.map((option) => option.deliveryDate);
  return new Date(Math.max(...dates));
});

const getClassForDate = (date) => {
  if (date.getTime() === minDate.value.getTime()) {
    return 'text-success-600';
  } else if (date.getTime() === maxDate.value.getTime()) {
    return 'text-error-500';
  } else {
    return 'text-warning-500';
  }
}

const getDeliveryText = (date) => {
  let result;

  if (date.getTime() === new Date().getTime()) {
    result = i18n.t('dnes');
  }
  else {
    result = formatDate(date);
  }

  return result;
}

const close = () => useDialog().close();

</script>
<style lang="postcss"></style>